export function getProductArchiveFilterSingleComponent(idBase) {
    return {
        name: 'ProductArchiveFilterSingle',
        props: {
            attribute: {
                type: Object,
                required: true,
            },
            isExpanded: {
                type: Boolean,
                required: true,
            },
            isHighlighted: {
                type: Boolean,
                required: false,
                default: false,
            },
            value: {
                type: Array,
                required: true,
            },
            products: {
                type: Array,
                required: true,
                default: [],
            },
        },
        data() {
            return {
                search: '',
                tabindex: '',
                model: [],
            };
        },
        watch: {
            value(value) {
                this.model = value;
            },
            model(model) {
                this.$emit('input', model);
                this.$emit('change', model);
            },
            isExpanded(isExpanded) {
                if (isExpanded === false) {
                    this.search = '';
                }
            },
            disabled(disabled) {
                if (this.isExpanded && disabled === true) {
                    this.$emit('toggle', { attribute: this.attribute });
                }
            },
        },
        computed: {
            disabled() {
                return this.hasValidOptions === false && this.model.length === 0;
            },
            type() {
                return this.isExpanded ? 'text' : 'button';
            },
            values() {
                return this.attribute.values.filter((value) => {
                    return value.text.toLowerCase().includes(this.search.toLowerCase());
                });
            },
            availableProducts() {
                const availableProducts = {};

                for (const option of this.attribute.values) {
                    availableProducts[option.value] = {
                        value: option,
                        available: this.products.filter((product) => {
                            const filterAttribute = this.attribute.name;

                            let showProduct;

                            if (/^(?:sub)*category$/.test(filterAttribute)) {
                                showProduct = (product?.categories ?? []).some(
                                    (category) => category.slug === option.value,
                                );
                            } else {
                                showProduct = option.value in (product?.attributes[filterAttribute] || {});
                            }

                            return Boolean(showProduct);
                        }).length,
                    };
                }

                return availableProducts;
            },
            hasValidOptions() {
                return (
                    Object.values(this.availableProducts)
                        .map(({ available }) => available)
                        .reduce((x, y) => x + y, 0) > 0
                );
            },
        },
        mounted() {},
        methods: {
            isDisabled(value) {
                return (this.availableProducts[value] ?? {}).available === 0 && this.model.includes(value) === false;
            },
            onToggle() {
                this.$emit('toggle', { attribute: this.attribute });

                if (this.isExpanded === false) {
                    this.tabindex = -1;
                    this.$nextTick(() => {
                        this.$refs.popup.focus();

                        this.tabindex = '';
                    });
                }
            },
            onFocus() {
                if (this.isExpanded === false) {
                    this.$emit('toggle', { attribute: this.attribute });
                }
            },
            onClearSearchClick() {
                this.search = '';
                this.$refs.search.focus();
            },
        },
        template: `#${idBase}-filter-single`,
    };
}
